import Axios from "../utils/Axios";

export const getStockCurrent = async () => {
  const response = await Axios.get("/in-out/month?month=current");
  return response.data;
};

export const getStockPast = async () => {
  const response = await Axios.get("/in-out/month?month=previous");
  return response.data;
};

export const downloadBarcode = async (barcode) => {
  const response = await Axios.get(`/in-out/download-barcode/${barcode}`, {
    responseType: "blob",
  });
  const blob = new Blob([response.data], { type: "image/png" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${barcode}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  return response.data;
};

export const getBarcodeDetails = async (barcode, status) => {
  try {
    const response = await Axios.get(`/in-out/barcode/${barcode}/${status}`);
    return response.data;
  } catch (error: any) {
    // Capture Flask error message
    const errorMessage = error.response?.data?.error || "Barcode Scan Failed";
    throw new Error(errorMessage);
  }
};

export const getStockCustom = async (month) => {
  const response = await Axios.get(`/in-out/month?month=${month}`);
  return response.data;
};

export const getInOutEntry = async (id) => {
  const response = await Axios.get(`/in-out/entry/${id}`);
  return response.data;
};

export const addInOut = async (formData) => {
  const response = await Axios.post("/in-out/add/", formData);
  return response.data;
};

export const editInOut = async (id, formData) => {
  const response = await Axios.put(`/in-out/edit/${id}`, formData);
  return response.data;
};

export const deleteInOut = async (id) => {
  const response = await Axios.delete(`/in-out/delete/${id}`);
  return response.data;
};
